export const authCs = {
  'Operator access': 'Přístup operátora',
  'Welcome back': 'Vítejte zpět',
  'Sign in to continue to your workspace.': 'Přihlaste se a pokračujte do pracovního prostoru.',
  'Enter your authenticator code to finish the secure session.': 'Zadejte kód z autentizační aplikace a dokončete zabezpečené přihlášení.',
  'Remember me': 'Zapamatovat si mě',
  'Forgot password': 'Zapomenuté heslo',
  'Sign in': 'Přihlásit se',
  'Verify code': 'Ověřit kód',
  'Back to password': 'Zpět k heslu',
  '2FA code': 'Kód 2FA',
  'By signing in, you agree to our': 'Přihlášením souhlasíte s našimi',
  'Terms of Service': 'Podmínkami používání',
  'Privacy Policy': 'Zásadami ochrany osobních údajů',
  'Need an account?': 'Potřebujete účet?',
  'Create one': 'Vytvořit účet',
  'Login failed': 'Přihlášení se nezdařilo',
  'Password reset is handled by your workspace administrator.': 'Obnovení hesla zajišťuje správce vašeho pracovního prostoru.',
  'Workspace access': 'Přístup do pracovního prostoru',
  'Create account': 'Vytvořit účet',
  'Start with the app frontend. Marketing stays on `linirio.com`.': 'Začněte v aplikaci. Marketingový web zůstává na `linirio.com`.',
  'Full name': 'Celé jméno',
  'Work email': 'Pracovní e-mail',
  'Already have an account?': 'Už máte účet?',
  'Please satisfy all password requirements.': 'Splňte prosím všechny požadavky na heslo.',
  'Registration failed': 'Registrace se nezdařila',
  'At least 8 characters': 'Alespoň 8 znaků',
  'One uppercase letter': 'Jedno velké písmeno',
  'One lowercase letter': 'Jedno malé písmeno',
  'One number': 'Jedna číslice',
  'One special character': 'Jeden speciální znak',
  'One workspace for outreach, approvals, and client-facing follow-up.': 'Jeden pracovní prostor pro outreach, schvalování a komunikaci s klienty.',
  'Linirio keeps the operator loop tight. Inbound messages, AI suggestions, and next-step tasks stay in one workflow.': 'Linirio drží práci operátora pohromadě. Příchozí zprávy, návrhy AI a navazující úkoly zůstávají v jednom workflow.',
  'Real inbox sync and operator review': 'Skutečná synchronizace schránky a kontrola operátorem',
  'Configurable AI reply approvals': 'Nastavitelné schvalování odpovědí AI',
  'Client task queue for quotes and meetings': 'Klientská fronta úkolů pro nabídky a schůzky',
  'Reports and audit in the same product shell': 'Reporty a audit ve stejném prostředí',
  'Secure AI workflow for': 'Bezpečné AI workflow pro',
  'conversations': 'konverzace',
  'approvals': 'schvalování',
  'and follow-ups.': 'a navazující kroky.',
  'Link not valid': 'Odkaz není platný',
  'Post rejected': 'Příspěvek byl zamítnut',
  'Your team has been notified.': 'Váš tým byl informován.',
  'Posted to LinkedIn 🎉': 'Publikováno na LinkedIn 🎉',
  'Approved & scheduled': 'Schváleno a naplánováno',
  'Note: a publishing error occurred — your team has been notified.': 'Poznámka: při publikování došlo k chybě — váš tým byl informován.',
  'Approve LinkedIn post': 'Schválit LinkedIn příspěvek',
};
